import Snackbar from "@mui/material/Snackbar";
import { Notification } from "pepsico-ds";
import "./_toast-notification.scss";

const ToastNotification = ({
  open,
  handleClose,
  type,
  title,
  description = "",
  primaryActionLabel = "Close",
  sx = {},
}) => {
  const formattedDescription = description
    ? description.split("\n").map((line, index, array) => (
        <span key={index}>
          {line}
          {index < array.length - 1 && <br />}
        </span>
      ))
    : "";

  return (
    <Snackbar
      className="toast-notification"
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={{ width: "97%", top: 0, ...sx }}
      message={
        <Notification
          type={type}
          title={title}
          text={formattedDescription}
          primaryActionLabel={primaryActionLabel || "Close"}
          primaryActionOnClick={handleClose}
        />
      }
    ></Snackbar>
  );
};

export default ToastNotification;
